// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalDataSourceNode
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { Message } from "abweb/dto/Message";
import { GraphicalDataSourceConnectionPoint } from "abweb/dto/gds/GraphicalDataSourceConnectionPoint";
import { GraphicalDataSourceEdge } from "abweb/dto/gds/GraphicalDataSourceEdge";
import { GraphicalDataSourceNode } from "abweb/dto/gds/GraphicalDataSourceNode";
import { GraphicalDataSourceObject } from "abweb/dto/gds/GraphicalDataSourceObject";
import { NamedDataSourceRecordReference } from "abweb/dto/gds/NamedDataSourceRecordReference";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalDataSourceNodeBase extends GraphicalDataSourceObject {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalDataSourceNodeBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalDataSourceNode";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalDataSourceNode(TSOGUtils.decodeObject(json.dataSourceRecordReference, NamedDataSourceRecordReference, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "dataSourceRecordReference")), json.id != null ? json.id : null, json.messages != null ? TSOGUtils.decodeObjectArray(json.messages, Message, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "messages")) : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.styleClasses != null ? json.styleClasses : null, json.viewType != null ? json.viewType : null, json.edges != null ? TSOGUtils.decodeObjectArray(json.edges, GraphicalDataSourceEdge, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "edges")) : null, json.height, json.incomingConnections != null ? TSOGUtils.decodeObjectArray(json.incomingConnections, GraphicalDataSourceConnectionPoint, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "incomingConnections")) : null, json.isCollapsible, json.isExpandable, json.isSeed, json.isWalkableBackward, json.isWalkableForward, json.nodes != null ? TSOGUtils.decodeObjectArray(json.nodes, GraphicalDataSourceNode, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "nodes")) : null, json.numChildren, json.outgoingConnections != null ? TSOGUtils.decodeObjectArray(json.outgoingConnections, GraphicalDataSourceConnectionPoint, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "outgoingConnections")) : null, json.walkBackwardContext != null ? json.walkBackwardContext : null, json.walkForwardContext != null ? json.walkForwardContext : null, json.width, json.x, json.y);
  }
  initGraphicalDataSourceNode(dataSourceRecordReference, id, messages, state, styleClasses, viewType, edges, height, incomingConnections, isCollapsible, isExpandable, isSeed, isWalkableBackward, isWalkableForward, nodes, numChildren, outgoingConnections, walkBackwardContext, walkForwardContext, width, x, y) {
    this.initGraphicalDataSourceObject(dataSourceRecordReference, id, messages, state, styleClasses, viewType);
    this._edges = edges;
    this._height = height;
    this._incomingConnections = incomingConnections;
    this._isCollapsible = isCollapsible;
    this._isExpandable = isExpandable;
    this._isSeed = isSeed;
    this._isWalkableBackward = isWalkableBackward;
    this._isWalkableForward = isWalkableForward;
    this._nodes = nodes;
    this._numChildren = numChildren;
    this._outgoingConnections = outgoingConnections;
    this._walkBackwardContext = walkBackwardContext;
    this._walkForwardContext = walkForwardContext;
    this._width = width;
    this._x = x;
    this._y = y;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._edges != null) {
      retVal["edges"] = TSOGUtils.toTSOGArray(this._edges, serializeContext);
    }
    retVal["height"] = this._height;
    if (this._incomingConnections != null) {
      retVal["incomingConnections"] = TSOGUtils.toTSOGArray(this._incomingConnections, serializeContext);
    }
    retVal["isCollapsible"] = this._isCollapsible;
    retVal["isExpandable"] = this._isExpandable;
    retVal["isSeed"] = this._isSeed;
    retVal["isWalkableBackward"] = this._isWalkableBackward;
    retVal["isWalkableForward"] = this._isWalkableForward;
    retVal["nodes"] = TSOGUtils.toTSOGArray(this._nodes, serializeContext);
    retVal["numChildren"] = this._numChildren;
    if (this._outgoingConnections != null) {
      retVal["outgoingConnections"] = TSOGUtils.toTSOGArray(this._outgoingConnections, serializeContext);
    }
    if (this._walkBackwardContext != null) {
      retVal["walkBackwardContext"] = this._walkBackwardContext;
    }
    if (this._walkForwardContext != null) {
      retVal["walkForwardContext"] = this._walkForwardContext;
    }
    retVal["width"] = this._width;
    retVal["x"] = this._x;
    retVal["y"] = this._y;
    return retVal;
  }
  get edges() {
    return this._edges;
  }
  set edges(value) {
    this._edges = value;
  }
  get height() {
    return this._height;
  }
  set height(value) {
    this._height = value;
  }
  get incomingConnections() {
    return this._incomingConnections;
  }
  set incomingConnections(value) {
    this._incomingConnections = value;
  }
  get isCollapsible() {
    return this._isCollapsible;
  }
  set isCollapsible(value) {
    this._isCollapsible = value;
  }
  get isExpandable() {
    return this._isExpandable;
  }
  set isExpandable(value) {
    this._isExpandable = value;
  }
  get isSeed() {
    return this._isSeed;
  }
  set isSeed(value) {
    this._isSeed = value;
  }
  get isWalkableBackward() {
    return this._isWalkableBackward;
  }
  set isWalkableBackward(value) {
    this._isWalkableBackward = value;
  }
  get isWalkableForward() {
    return this._isWalkableForward;
  }
  set isWalkableForward(value) {
    this._isWalkableForward = value;
  }
  get nodes() {
    return this._nodes;
  }
  set nodes(value) {
    this._nodes = value;
  }
  get numChildren() {
    return this._numChildren;
  }
  set numChildren(value) {
    this._numChildren = value;
  }
  get outgoingConnections() {
    return this._outgoingConnections;
  }
  set outgoingConnections(value) {
    this._outgoingConnections = value;
  }
  get walkBackwardContext() {
    return this._walkBackwardContext;
  }
  set walkBackwardContext(value) {
    this._walkBackwardContext = value;
  }
  get walkForwardContext() {
    return this._walkForwardContext;
  }
  set walkForwardContext(value) {
    this._walkForwardContext = value;
  }
  get width() {
    return this._width;
  }
  set width(value) {
    this._width = value;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
  }
}
//# sourceMappingURL=GraphicalDataSourceNodeBase.js.map
